import reducer from './reducers';

import mallOperations from './operations';
import { types as mallTypes } from './actions';

export { mallOperations, mallTypes };

export default reducer;
